import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import Console from '@/components/landing/console/console'

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='Console'
                description='An operable retro CRT computer — type a command and the green-phosphor screen becomes the website.'
            />

            <Console />
        </>
    )
}

export default Home
